<mat-drawer-container autosize>

    <mat-drawer class="pt-5" #drawer mode="side" [opened]="openleftpane" >
      <div class="mat-title py-3">
        <strong class="pl-4">Business processes</strong>
      </div>
      <div class="py-3 px-1" *ngIf="processes.length > 0">
        <div *ngFor="let entry of processes;let i = index">
          <div class="py-2 m-2 sectionHover" class="row col-12 px-0 py-2 px-3"
            style="font-weight:500;cursor: pointer;display:flex;" (click)="onClickOfProcessUpdated(i)"
            [ngClass]="{'selected-style': entry.isSelected }">
            <mat-icon class="col-1 mt-1 ml-1 bulletIcon">lens</mat-icon>
            <div class="col-10 pr-0 mat-subheading-2 pt-1"> {{entry.businessProcessName}}</div>
          </div>
        </div>
      </div>
      <div *ngIf="processes.length == 0" class="p-4">
        <span class="p-3 mat-body-1">No business processes available</span>
      </div>
    </mat-drawer>;

  
  <mat-drawer-content class="drawer-content-bodyScroll" *ngIf="processes.length > 0">
    <!-- <div class="sidenav-content"> -->
      <!-- <div  class="mat-drawer-content-container" 
      [ngClass]="{'mTop':hideCreateIncident,'pt-4' : processes.length == 0}">
        <img src="/assets/icons/BusinessProcess1.svg" alt="" height="25px" aria-label="processLogo" />
        <strong *ngIf="processes.length == 1" class="mat-drawer-content-title mat-title pl-3">{{(selectedProcess != null) ? selectedProcess.businessProcessShortText : 'Business process'}}</strong>
        <strong *ngIf="processes.length > 1" class="mat-drawer-content-title mat-title pl-3">Business process</strong>
      </div> -->
        <!-- <strong *ngIf="userRole == 'Survey Respondent'" class="mat-drawer-content-title mat-title pl-3">{{(selectedProcess != null) ? selectedProcess.businessProcessShortText : ' '}}</strong>
        <h1 *ngIf="userRole != 'Survey Respondent'" class="mat-drawer-content-title mat-title pl-3">Business process</h1>
      </div> -->
      <div class="row mt-4 ml-5 pad" style="margin-top: 85px;" *ngIf="!isSurveyExpired && isSurveyActive && !hideCreateIncident && !adminUserTypes.includes(userRole.toLowerCase())">
        <button mat-stroked-button color="primary" class="button-drawer mb-3" (click)="CreateNewIncident()"> Create New
          {{selectedProcess != null ? selectedProcess.businessProcessShortText : ' '}}</button>
      </div>
      <div *ngIf="processes.length > 0 && userRole != null && userRole != 'Respondent'" [ngStyle]="{'margin-top': (isSurveyExpired || !isSurveyActive || hideCreateIncident || userRole.toLowerCase() == 'group admin') ? '3rem' : '0rem'}">
       

       <mat-accordion class="row mt-3 mx-5 panelBorder" multi>
          <mat-expansion-panel (opened)="filterOpen($event)" class="w-100 mat-elevation-z0" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <p class="m-4 lightBlue mat-subheading-1">Apply search filters</p>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <!-- <div class="row d-flex align-items-center" *ngIf="entities != null && entities.length > 1">
                <div class="col-1"> Entity </div>
                <div class="col-2 px-2">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-select  name="entityControl" [(ngModel)]="selectedEntityId"
                      (selectionChange)="entityChange($event)">
                      <mat-option *ngFor="let entity of entities;" [value]="entity.entityID">
                        {{entity.entityName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div> -->

              <!--Basic Filters-->
              <!-- <div class="row pl-3 d-flex align-items-center" *ngIf="entities != null && entities.length > 1">
                <p class="mat-subheading-1  lightBlue">Basic filters</p>
              </div> -->
              <div class="row mx-5 mt-1" style="display:flex !important;flex-wrap: wrap !important;justify-content: space-between;" *ngIf="searchData != null && searchData.length > 0">
                <div class="row col-5 mx-2 pl-0 filter-fields" style="height:10%" *ngFor="let entry of searchData; let i=index">   
                  <div class="col-4 px-1 mr-2 align-items-center"> {{entry.displayName}}</div> 
                  <div class="col-7 px-1">
                    <ng-container *ngIf="entry.filterType == 'string'">
                      <input class="w-100 filtSelect" [(ngModel)]="entry.value"
                      (input)="onSearchCriteriea($event, entry)" [ariaLabel]="entry.displayName">                      
                    </ng-container>                    
                    <ng-container *ngIf="entry.filterType == 'dropdown' && entry.dropdownData != null">                     
                      <mat-select class="filtSelect" placeholder="Select {{entry.displayName}}" [(ngModel)]="entry.value"
                      (selectionChange)="onSearchCriteriea($event, entry)">
                        <mat-option *ngFor="let d of entry.dropdownData;let i = index" [value]="d">
                          {{ d }}
                        </mat-option>
                      </mat-select>     
                    </ng-container>
                  </div>              
                </div>     
              </div>


              <!--Advanced Entity Filters-->
              <!-- <div class="row pl-3 d-flex align-items-center" *ngIf="!noAdvFilters">
                <p class="mat-subheading-1  lightBlue">Advanced filters</p>
              </div> -->
              <!-- <div class="row mx-5 mt-1" style="display:flex !important;flex-wrap: wrap !important;justify-content: space-between;" *ngIf="searchData != null && searchData.length > 0 && !noAdvFilters"> -->

                <!-- <div class="row col-5 mx-2 pl-0 filter-fields" *ngFor="let field of searchableFields; let i=index">

                  <div class="col-4 px-1 mr-2 align-items-center"> {{field.entityFieldName}}</div>
                  <div class="col-6 px-1">
                    <ng-container *ngIf="field.questionMasters.inputType == 'dte'">
                      <input class="blue-border ht-30 w-100" id="{{field.questionMasters.questionId}}" type="date" />
                    </ng-container>
                    <ng-container *ngIf="field.questionMasters.inputType != 'dte'">
                      <input id="{{field.questionMasters.questionId}}" class="blue-border ht-30 w-100"
                        (change)="onSearch($event,field)">
                    </ng-container>
                  </div>

                </div>
                <div *ngIf="searchableFields.length == 0" class="mx-2">
                  <div class="d-flex justify-content-center mat-subheading-1">No Advanced Filters set</div>
                </div> -->



                 <!--New filters-->              
                <!-- <div class="row col-5 mx-2 pl-0 filter-fields" style="height:10%" *ngFor="let entry of searchData  | filterCategory: 'Entity'; let i=index">   
                  <div class="col-4 px-1 mr-2 align-items-center"> {{entry.displayName}}</div> 
                  <div class="col-7 px-1">
                    <ng-container *ngIf="entry.filterType == 'string'">
                      <input class="w-100 filtSelect" [(ngModel)]="entry.value"
                      (input)="onSearchCriteriea($event, entry)" [ariaLabel]="entry.displayName" >                      
                    </ng-container>                    
                    <ng-container *ngIf="entry.filterType == 'dropdown' && entry.dropdownData != null">                     
                      <mat-select class="filtSelect" placeholder="Select {{entry.displayName}}" [(ngModel)]="entry.value"
                      (selectionChange)="onSearchCriteriea($event, entry)">
                        <mat-option *ngFor="let d of entry.dropdownData;let i = index" [value]="d">
                          {{ d }}
                        </mat-option>
                      </mat-select>     
                    </ng-container>
                  </div>              
                </div>        -->


              <!-- </div> -->
            </div>
            <mat-action-row class="pr-4">
              <button mat-raised-button class="apply-button" [disabled]="searchData.length == 0"
                (click)="search()">Search</button>
              <button mat-raised-button [disabled]="searchData.length == 0" class="apply-button"
                (click)="reset()">Reset</button>
            </mat-action-row>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <!-- <div *ngIf="isWorkFlowExists && userRole != null && userRole != 'Respondent'" class="mt-5 mr-5 row d-flex justify-content-end">
        <i aria-hidden="true" class="fa fa-circle pr-2 font16 black"></i><span class="font14">No action needed</span>
        <i aria-hidden="true" class="fa fa-circle px-2 font16 yellow"></i><span class="font14">Action needed</span>
        <i aria-hidden="true" class="fa fa-circle px-2 font16 green"></i><span class="font14">Step completed</span>
        <i aria-hidden="true" class="fa fa-circle px-2 font16 red"></i><span class="font14">Step overdue</span>
      </div> -->

      
     <!-- Instance Data Table       -->
    <div class="row mt-3 mx-5 ttlborder" [ngClass]="{'mt-5': (isSurveyExpired || !isSurveyActive || hideCreateIncident) && userRole && userRole.toLowerCase() != 'group admin'}"  *ngIf="instanceDataSource && instanceDataSource.data && instanceDataSource.data.length > 0">
      <div class="w-100 overflow-x" aria-describedby="BusinessProcessDataTable">
        <table  mat-table id="BusinessProcessDataTable"
          [dataSource]="instanceDataSource" matSort #instanceSort="matSort"
          class="tblscroll" multiTemplateDataRows (matSortChange)="sortInstanceDataSource($event)">
          <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index" matColumnDef="{{disCol}}">
            <th mat-header-cell *matHeaderCellDef class="table-heading" mat-sort-header>
              <strong>{{ getColumnHeader(disCol) }}</strong>
            </th>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="disCol">
                <span *ngSwitchCase="'UserSurveyResponseId'">{{ formatPbcId(element.value[disCol]) }}</span>
                <span *ngSwitchCase="'SurveyInstanecId'">{{ element.label }}</span>
                <span *ngSwitchCase="'PbcEvaluationOutcome'">{{ element.value[disCol] || '' }}</span>
                <span *ngSwitchCase="'Tier Requested'">{{defaultTier!==""?defaultTier: surveyDisputeConfig?.selectedTierCode}}</span>
                <ng-container *ngSwitchCase="'EditDelete'">
                  
                  <!-- Show normal action icons for non-historical records -->
                  <ng-container *ngIf="!element.value['IsHistorical']">
                  <div style="display: flex;justify-content: left;align-items: center;">
                      <mat-icon class="cursor gray" *ngIf="isSurveyActive && !isSurveyExpired && userRole?.toLowerCase() != 'group admin' && (element.value['SurveyStatus'] == 'PE' || (element.value['SurveyStatus'] == 'CP' && isResubmissionAllowed))"
                        matTooltip="Edit" (click)="existingIncident(element.label,element)">edit</mat-icon>
                      <mat-icon class="cursor gray" *ngIf="isSurveyExpired || !isSurveyActive || userRole?.toLowerCase() == 'group admin' ? true : (element.value['SurveyStatus'] == 'CP' && !isResubmissionAllowed)" matTooltip="View"
                        (click)="existingIncident(element.label,element,null,'view')">remove_red_eye</mat-icon>
                      <mat-icon class="gray" matTooltip="No Action"
                                *ngIf="element.value['SurveyStatus'] == 'NoIcon'">visibility_off</mat-icon>
                      <mat-icon matTooltip="View Log" style="padding-top:1px;font-size: 20px;overflow: visible !important;"
                                (click)="openIncidentHistory(element.value['IncidentLogs']); $event.stopPropagation()" class="ml-2 lightBlue"
                                *ngIf="element.value['IncidentLogs'] != null && element.value['IncidentLogs'].length > 0">
                        assignment
                      </mat-icon>
                      <button mat-icon-button [matMenuTriggerFor]="downloadMenu" class="ml-2 lightBlue"
                              matTooltip="Download Options"
                              *ngIf="userRole && userRole == 'Respondent' && element.value['wfOverallStatus'] == 'Completed'"  
                              (click)="$event.stopPropagation()">
                        <mat-icon style="font-size: 26px;">download</mat-icon>
                      </button>
                      <mat-menu #downloadMenu="matMenu">
                        <button mat-menu-item (click)="onDownload(element, 'attestationpdf'); $event.stopPropagation()">
                          <mat-icon>picture_as_pdf</mat-icon>
                          <span>Attestation PDF</span>
                        </button>
                        <button mat-menu-item (click)="onDownload(element, 'excel'); $event.stopPropagation()">
                          <mat-icon>description</mat-icon>
                          <span>Excel</span>
                        </button>
                        <button mat-menu-item (click)="onDownload(element, 'allattachments'); $event.stopPropagation()">
                          <mat-icon>folder_zip</mat-icon>
                          <span>All Attachments (ZIP)</span>
                        </button>
                      </mat-menu>


                      <button mat-icon-button *ngIf="surveyDisputeConfig != null && surveyDisputeConfig.surveyDisputeConfigId > 0
                        && !surveyDisputeConfig.isDisputeDisabled
                        && element.value['wfOverallStatus'] == 'Completed'
                        && ((element.value.showRaiseDisputeBtn && userRole && userRole == 'Respondent')
                        || (element.value.latestDispute && element.value.latestDispute.status !== appConstants.disputeStatus.RAISED && userRole && userRole == 'Respondent')
                        || (element.value.latestDispute && element.value.latestDispute.status === appConstants.disputeStatus.RAISED))" 
                       [matMenuTriggerFor]="disputeMenu" class="lightBlue"
                              matTooltip="Resolution Options" (click)="$event.stopPropagation()">
                        <mat-icon style="font-size: 22px;">flag</mat-icon>
                      </button>
                      <mat-menu #disputeMenu="matMenu">
                        <button mat-menu-item *ngIf="element.value.showRaiseDisputeBtn && userRole && userRole == 'Respondent'"
                        (click)="existingIncident(element.label,element,null,null,'raiseDispute'); $event.stopPropagation()">
                          <mat-icon>flag</mat-icon>
                          <span>Start Resolution</span>
                        </button>
                        <button mat-menu-item *ngIf="element.value.latestDispute && element.value.latestDispute.status !== appConstants.disputeStatus.RAISED && element.value.isActiveDispute  && userRole && userRole == 'Respondent'"
                        (click)="existingIncident(element.label,element,null,null,'editDispute'); $event.stopPropagation()">
                          <mat-icon>rate_review</mat-icon>
                          <span>Edit Resolution</span>
                        </button>
                        <button mat-menu-item *ngIf="element.value.latestDispute && element.value.latestDispute.status === appConstants.disputeStatus.RAISED"
                        (click)="existingIncident(element.label,element,null,null,'viewDispute'); $event.stopPropagation()">
                          <mat-icon>check_circle</mat-icon>
                          <span>View Resolution</span>
                        </button>

                        <!-- resolution download  -->
                        <button mat-menu-item *ngIf="element.value.latestDispute && element.value.latestDispute.disputeId > 0"
                        (click)="onResolutionDownload(element, 'excel'); $event.stopPropagation()">
                          <mat-icon>description</mat-icon>
                          <span>Download Excel</span>
                        </button>
                        <button mat-menu-item *ngIf="element.value.latestDispute && element.value.latestDispute.disputeId > 0"
                        (click)="onResolutionDownload(element, 'allattachments'); $event.stopPropagation()">
                          <mat-icon>folder_zip</mat-icon>
                          <span>All Attachments (ZIP)</span>
                        </button>
                      </mat-menu>
                  
                  </div>
                  </ng-container>
                <!-- Show only visibility_off for historical records -->
                <ng-container *ngIf="element.value['IsHistorical']">
                  <mat-icon class="gray" matTooltip="Historical Record">visibility_off</mat-icon>
                </ng-container>
                </ng-container>
                <!-- <ng-container *ngSwitchCase="'Icon'">
                  <mat-icon matTooltip="View workflow status" style="padding-right:10px;cursor: pointer;padding-top: 3px;">
                    {{expandedElement === element ? 'expand_less' : 'expand_more'}}
                  </mat-icon>
                </ng-container> -->
                <span *ngSwitchDefault>{{ element.value[disCol] }}</span>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="header-row-first-group">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length" class="borderRad">
              <div class="mat-subheading-1 text-left heading-color">
                <p class="header-mat-panel-title mat-subheading-1 ">List of PBC Submissions</p>
              </div>
            </th>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div class="overflow-x" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                <div *ngIf="element.value['ExpandWFDetails'] != null && element.value['ExpandWFDetails'].step.length > 0 ">
                  <p class="m-1"><strong>Initiated by</strong> : <span
                      class="font14">{{element.value['ExpandWFDetails'].initialtedByUserName}}</span></p>
                  <p class="m-1"><strong>Workflow status</strong> : <span
                      class="font14">{{element.value['ExpandWFDetails'].wfStatusDescription}}</span></p>
                </div>
                <div class="card-deck ml-2"
                  *ngIf="element.value['ExpandWFDetails'] != null && element.value['ExpandWFDetails'].step.length > 0 ">
                  <ng-container *ngFor="let entry of element.value['ExpandWFDetails'].step; let i = index">
                    <div class="card m-4 col-4 p-0 mat-elevation-z2 stepHov">
                      <div class="card-head"
                        [ngClass]="{'cursor': ((entry.isAssigned && entry.stepStatus != 'CP' &&  (i > 0 && element.value['ExpandWFDetails'].step[i -1] != null && element.value['ExpandWFDetails'].step[i -1].stepStatus == 'CP')) || entry.stepStatus == 'CP' || (entry.isAssigned && entry.stepStatus != 'CP' && i == 0))
                       ,'noCursor noEvent': (entry.stepStatus != 'CP' && (!entry.isAssigned || entry.disableClick)) || (getStatusColor_NEW(entry.stepStatusDescription,entry.disableClick,entry.isOverdue,element.value['ExpandWFDetails'].step,i) == 'black' )}">
                        <span class="dot mr-3"
                          [ngStyle]="{'background-color': getStatusColor_NEW(entry.stepStatusDescription,entry.disableClick,entry.isOverdue,element.value['ExpandWFDetails'].step,i)}">
                        </span>
                        <span [ngClass]="{'underline':((entry.isAssigned && entry.stepStatus != 'CP' &&  (i > 0 && element.value['ExpandWFDetails'].step[i -1] != null && element.value['ExpandWFDetails'].step[i -1].stepStatus == 'CP')) || entry.stepStatus == 'CP' || (entry.isAssigned && entry.stepStatus != 'CP' && i == 0)),
                      'block-action': entry.stepStatus != 'CP' && (!entry.isAssigned || entry.disableClick) }"
                          (click)="existingIncident(element.label,element,entry)"
                          class="mat-body-1 mt-3">{{entry.stepName}}
                        </span>
                      </div>
                      <div class="card-body">
                        <p class="card-body-text"><span class="mat-body-2">Assigned on </span>: <span
                            class="mat-body-1">{{entry.stepAssignedOn}}</span></p>
                        <p class="card-body-text"><span class="mat-body-2">Status</span> : <span
                            class="mat-body-1">{{entry.configuredStatus != null && entry.configuredStatus.length > 0 ?
                            entry.configuredStatus :entry.stepStatusDescription}}</span></p>
                        <p class="card-body-text" *ngIf="entry.stepStatus == 'CP'"><span class="mat-body-2">Completed
                            by</span> : <span class="mat-body-1">{{entry.completedBy}}</span></p>
                        <p class="card-body-text" *ngIf="entry.stepStatus == 'CP'"><span class="mat-body-2">Completed
                            on </span>: <span class="mat-body-1">{{entry.completedOn }}</span></p>
                        <p class="card-body-text" *ngIf="entry.stepStatus == 'PE'"><span class="mat-body-2">Last
                            updated on</span> : <span class="mat-body-1">{{entry.lastUpdatedOn}}</span></p>
                        <p class="card-body-text" *ngIf="entry.stepStatus == 'NE' || entry.stepStatus == 'PE'"><span
                            class="mat-body-2">Assigned to</span> : <span
                            class="mat-body-1">{{entry.assignedToUser}}</span></p>
                        <p class="card-body-text"
                          *ngIf="(entry.stepStatus == 'PE' || entry.stepStatus == 'CP') && entry.dueDate != null &&  entry.dueDate.length > 0">
                          <span class="mat-body-2">Due date</span> : <span class="mat-body-1">{{entry.dueDate}}</span>
                        </p>
                        <p class="card-body-text" *ngIf="entry.isDueDateEnabled && entry.dueDate == null"><span
                            class="mat-body-2">Due date</span> : <span class="mat-body-1">{{'NA'}}</span></p>
                      </div>
                    </div>
                    <div *ngIf="element.value['ExpandWFDetails'].step.length - 1 > i">
                      <mat-icon class="pt-5 mt-5">arrow_right_alt</mat-icon>
                    </div>
                  </ng-container>
                  <mat-icon></mat-icon>
                  <div class="m-3"
                    *ngIf="element.value['ExpandWFDetails'] == null && element.value['ExpandWFDetails'].step.length == 0">
                    No data present
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row class="tableHeading" *matHeaderRowDef="['header-row-first-group'];sticky: true"></tr>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
          <!-- <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
            [class.example-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element; workflowTitles(element.value['UserSurveyResponseId'],element);">
          </tr> -->
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
      </div>
      <div *ngIf="userRole != null && userRole.toLowerCase() != 'respondent'" class="pagination1 w-100 borderRadBtm">
        <mat-paginator #instancePaginator [pageSize]="size" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
    </div>

      <div *ngIf="instanceDataSource == null || instanceDataSource.data == null || instanceDataSource.data.length == 0" class="row m-5 blue-border"
        [ngClass]="{'mt-5' : processes.length == 0}">
        <mat-card class="row col-md-12 ml-md-0 my-3 remShad">
          <span class="font14 lightBlue">No Application found</span>
        </mat-card>
      </div>


      <div class="arrow-btn-style" (click)="drawer.toggle();changeArrowIcon();" *ngIf="openleftpane"
        (keypress)="drawer.toggle();changeArrowIcon();">       
            <img class="sidetoggle" *ngIf="arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
            <img class="sidetoggle" *ngIf="!arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
      </div>

      <!-- Performance Measures Section - Render only when data is available and user is not admin -->
      <!-- Performance Measures Section - Conditional rendering based on providerType -->
      <div class="mt-4" *ngIf="performanceAreas && performanceAreas.length > 0 && !isAdminUser()">
        <app-performance-measures *ngIf="providerType === 'SCO'" [performanceAreas]="performanceAreas"></app-performance-measures>
        <app-odp-resolution-performance-measures *ngIf="providerType === 'RS' && tierMeasureRequirements.length > 0 && isReviewCompleted" [performanceAreas]="performanceAreas" [tierMeasureRequirements]="tierMeasureRequirements" [selectedTierCode]="surveyDisputeConfig?.selectedTierCode"></app-odp-resolution-performance-measures>
        <app-odp-performance-measures *ngIf="providerType === 'RS' && tierMeasureRequirements.length > 0 && !isReviewCompleted" [performanceAreas]="performanceAreas" [tierMeasureRequirements]="tierMeasureRequirements"></app-odp-performance-measures>
      </div>
  
  </mat-drawer-content>
</mat-drawer-container>
